import { useCountdown } from "@/hooks/useCountdown";
import { Card } from "@/components/ui/card";

interface UpcomingMatch {
  date: string;
  homeTeam: string;
  awayTeam: string;
  time: string;
  competition: string;
  matchDate?: string;
}

export const UpcomingMatchCard = ({ match }: { match: UpcomingMatch }) => {
  const countdown = useCountdown(match.matchDate || match.date, match.time);

  return (
    <Card className="p-4 md:p-8 bg-dark-red border-4 border-golden-yellow rounded-3xl shadow-2xl hover:scale-[1.02] transition-transform">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-8">
        <div className="w-full md:w-32 text-center md:text-left flex-shrink-0">
          <div className="text-sm font-bold text-golden-yellow/70 mb-1">
            <span className="font-black">{match.time} Uhr</span>
          </div>
          <div className="text-sm font-bold text-golden-yellow/70 mb-1">
            <span className="font-black">{match.date}</span>
          </div>
          <div className="text-sm font-bold text-golden-yellow/70">
            <span className="font-black">{match.competition}</span>
          </div>
        </div>
        
        <div className="w-full md:flex-1 flex flex-col items-center justify-center gap-3 md:gap-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-8 w-full">
            <div className="text-center md:text-right w-full md:w-56 flex-shrink-0">
              <div className="text-xl md:text-2xl font-black text-golden-yellow break-words overflow-wrap-anywhere">{match.homeTeam}</div>
            </div>
            
            {!countdown.isExpired ? (
              <div className="flex flex-col items-center bg-golden-yellow px-4 py-2 md:px-10 md:py-4 rounded-2xl w-full md:w-[380px] md:flex-shrink-0">
                <div className="flex items-center gap-0 md:gap-0">
                  <div className="flex items-center">
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">{countdown.days}</div>
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">G</div>
                  </div>
                  <div className="text-2xl md:text-4xl font-black text-dark-red leading-none mx-1">:</div>
                  <div className="flex items-center">
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">{countdown.hours}</div>
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">S</div>
                  </div>
                  <div className="text-2xl md:text-4xl font-black text-dark-red leading-none mx-1">:</div>
                  <div className="flex items-center">
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">{countdown.minutes}</div>
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">D</div>
                  </div>
                  <div className="text-2xl md:text-4xl font-black text-dark-red leading-none mx-1">:</div>
                  <div className="flex items-center">
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">{countdown.seconds}</div>
                    <div className="text-2xl md:text-4xl font-black text-dark-red leading-none">S</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex items-center bg-golden-yellow px-4 py-2 md:px-10 md:py-4 rounded-2xl w-full md:w-[380px] md:flex-shrink-0 justify-center">
                <div className="text-3xl md:text-5xl font-black text-dark-red leading-none">VS</div>
              </div>
            )}
            
            <div className="text-center md:text-left w-full md:w-56 flex-shrink-0">
              <div className="text-xl md:text-2xl font-black text-golden-yellow break-words overflow-wrap-anywhere">{match.awayTeam}</div>
            </div>
          </div>
        </div>
        
        <div className="hidden md:block md:w-32"></div>
      </div>
    </Card>
  );
};
